import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UntypedFormGroup, UntypedFormBuilder, Validators} from '@angular/forms';

@Component({
    selector: 'app-new-user',
    templateUrl: './new-user.component.html',
    styleUrls: ['./new-user.component.css'],
    standalone: false
})
export class NewUserComponent implements OnInit {

  form: UntypedFormGroup;
  name: string = "";
  surname: string = "";
  email: string = "";
  password: string = "";
  active: string = "true";
  permiso_total: boolean = false;
  permiso_pesar: boolean = false;
  permiso_clasificar: boolean = false;
  permiso_registros: boolean = false;
  permiso_registrosDatos: boolean = false;
  permiso_registrosPesos: boolean = false;
  permiso_usuarios: boolean = false;
  permiso_contenedores: boolean = false;
  permiso_contenedores_alta_movimientos: boolean = false;
  permiso_contenedores_alta_mantenimientos: boolean = false;

  constructor(private fb: UntypedFormBuilder, @Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<NewUserComponent>) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      name: [this.name, [Validators.required, Validators.minLength(1), Validators.maxLength(64)]],
      surname: [this.surname, [Validators.required, Validators.minLength(1), Validators.maxLength(64)]],
      email: [this.email, [Validators.required, Validators.minLength(1), Validators.maxLength(128), Validators.pattern("[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.+[a-zA-Z]{2,4}$")]],
      password: [this.password, [Validators.required, Validators.minLength(8), Validators.maxLength(24)]],
      active: [this.active, [Validators.required]],
    });
  }

  save() {
    const {value, valid} = this.form;
    if(valid){
      var data = [{
        'name': value["name"],
        'surname': value["surname"],
        'email': value["email"],
        'active': value["active"],
        'permiso_total': this.permiso_total,
        'permiso_pesar': this.permiso_pesar,
        'permiso_clasificar': this.permiso_clasificar,
        'permiso_registros': this.permiso_registros,
        'permiso_registrosDatos': this.permiso_registrosDatos,
        'permiso_registrosPesos': this.permiso_registrosPesos,
        'permiso_usuarios': this.permiso_usuarios,
        'permiso_contenedores': this.permiso_contenedores,
        'permiso_contenedores_alta_movimientos': this.permiso_contenedores_alta_movimientos,
        'permiso_contenedores_alta_mantenimientos': this.permiso_contenedores_alta_mantenimientos,
      }];
      this.dialogRef.close(data);
    }
  }

  close() {
    this.dialogRef.close();
  }

}
